import { loc } from "../i18n/survey";

enum NutritionTrackingApp {
  Yes = "Yes",
  Not_right_now="I have in the past",
  No = "No",

}

const nutritionTrackingAppQuestion = {
  name: "nutritiontrackingapp",
  descriptionLocation: "underTitle",
  title: loc("quiz.trackingApp.nutritionTitle"),
  description: loc("quiz.shared.startingPoint"),
  type: "radiogroup",
  choices: [
    { value: NutritionTrackingApp.Yes, text: loc("quiz.trackingApp.choices.yes") },
    { value: NutritionTrackingApp.Not_right_now, text: loc("quiz.trackingApp.choices.inThePast") },
    { value: NutritionTrackingApp.No, text: loc("quiz.trackingApp.choices.no") },
  ],
  isRequired: true,
};

export { NutritionTrackingApp, nutritionTrackingAppQuestion };
